<template lang="pug">
div
  .odds.text-muted(v-if="[41, 42, 43, 44, 45, 46, 47, 49, 50, 51, 52].includes(menu2)")
    i.fad.fa-lock-alt
  .odd-box(v-else)
    .odd.lock
      i.fad.fa-lock-alt
</template>

<script>
export default {
  computed: {
    menu2() {
      return this.$store.getters.menu2;
    }
  }
}
</script>